import * as Types from '../types';

import {gql} from '@apollo/client';
export type PosterDetailsFragment = {
  __typename?: 'Poster';
  id: string;
  name: string;
  variant: Types.PosterVariant;
  activitiesStartDate: any;
  activitiesEndDate: any;
  activityTypes: Array<Types.ActivityType>;
  baseColor: any;
  highlightColor: any;
};

export const PosterDetailsFragmentDoc = gql`
  fragment posterDetails on Poster {
    id
    name
    variant
    activitiesStartDate
    activitiesEndDate
    activityTypes
    baseColor
    highlightColor
  }
`;
